import "../App.css";

import tokenomics from "../assets/images/tokenomics.png";

import community from "../assets/images/community.png";
import globe from "../assets/images/globe.png";
import loop from "../assets/images/loop.png";
import gift from "../assets/images/gift.png";
import binance from "../assets/images/binance.png";

const features = [

    {
        icon: community,
        title: "Community\nGrowth",
        text: "Stronger community, stronger network."
    },

    {
        icon: globe,
        title: "Travel\nUtility",
        text: "Real use case in the travel industry."
    },

    {
        icon: loop,
        title: "Buybacks",
        text: "Revenue fuels buybacks, regularly."
    },

    {
        icon: gift,
        title: "Holder\nRewards",
        text: "Buybacks are shared with holders."
    },

    {
        icon: binance,
        title: "BSC\nPower",
        text: "Built on the fast and low-fee BNB Chain."
    }

];

function Tokenomics() {

    return (

        <section className="tokenomics-section" id="tokenomics">

            <div className="container">

                <div className="row">

                    <div className="col-lg-5 mb-4 mb-lg-0">

                        <div className="tokenomics-card">

                            <div className="tokenomics-content">

                                <h2>TOKENOMICS</h2>

                                <span className="title-line"></span>

                                <small>TOTAL SUPPLY</small>

                                <h3>

                                    1,000,000,000

                                    <br />

                                    $GOOSE

                                </h3>

                                <ul>

                                    <li>Fair launch.</li>
                                    <li>No team allocation.</li>
                                    <li>No presale.</li>
                                    <li>100% to the community.</li>

                                </ul>

                            </div>

                            <img
                                src={tokenomics}
                                alt=""
                                className="tokenomics-mobile-image"
                            />

                        </div>

                    </div>

                    <div className="col-lg-7">

                        <div className="hold-card">

                            <h2>WHY HOLD $GOOSE</h2>

                            <span className="title-line"></span>

                            <div className="hold-grid">

                                {

                                    features.map((item,index)=>(

                                        <div
                                            className="hold-item"
                                            key={index}
                                        >

                                            <img
                                                src={item.icon}
                                                alt=""
                                            />

                                            <h4>

                                                {

                                                    item.title.split("\n").map((line,i)=>

                                                        <span key={i}>

                                                            {line}

                                                            <br/>

                                                        </span>

                                                    )

                                                }

                                            </h4>

                                            <p>{item.text}</p>

                                        </div>

                                    ))

                                }

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </section>

    );

}

export default Tokenomics;